import { useEffect, useRef } from "react";
import { animate } from "framer-motion";

export const AnimatedNumber = ({ value = 0, decimals = 1, testId, className = "" }) => {
  const ref = useRef(null);
  const prev = useRef(0);

  useEffect(() => {
    const controls = animate(prev.current, Number(value) || 0, {
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = v.toLocaleString("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      },
    });
    prev.current = Number(value) || 0;
    return () => controls.stop();
  }, [value, decimals]);

  return (
    <span ref={ref} data-testid={testId} className={className}>
      {(Number(value) || 0).toFixed(decimals)}
    </span>
  );
};
